import { SECTION_COPY } from "../copy";
import voiceIcon from "../../../Assets/icon/explore/voice.svg";
import keyboardIcon from "../../../Assets/icon/explore/keyboard.svg";

/**
 * TALK_WITH_ARIS (Figma 9154:8266) — always present, the fallback when nothing
 * in the feed fits. Voice and Text start the conversation directly, the same
 * two destinations the Aris tab's chooser uses. Copy is frontend-owned: the
 * backend sends only keys.
 */
function TalkWithArisSection({ onTalkVoice, onTalkText }) {
  const c = SECTION_COPY.TALK_WITH_ARIS;
  return (
    <section className="ex-talk">
      <span className="ex-talk__glow ex-talk__glow--left" aria-hidden="true" />
      <span className="ex-talk__glow ex-talk__glow--right" aria-hidden="true" />
      <h2 className="ex-talk__title">{c.title}</h2>
      <p className="ex-talk__body">{c.subtitle}</p>
      <div className="ex-talk__options">
        <button type="button" className="ex-talk__option" onClick={onTalkVoice}>
          <span className="ex-talk__circle">
            <img src={voiceIcon} alt="" width="32" height="32" />
          </span>
          {c.voice}
        </button>
        <button type="button" className="ex-talk__option" onClick={onTalkText}>
          <span className="ex-talk__circle">
            <img src={keyboardIcon} alt="" width="32" height="32" />
          </span>
          {c.text}
        </button>
      </div>
    </section>
  );
}

export default TalkWithArisSection;
